import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CloseIcon from '@mui/icons-material/Close';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Box, IconButton, Paper, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { ChatSubtitle, ChatTitle } from '../chatConfig';
import ChatComposer from './chatComposer';
import ChatThread from './chatThread';

ChatPanel.propTypes = {
	messages: PropTypes.array.isRequired,
	isSending: PropTypes.bool,
	onSend: PropTypes.func.isRequired,
	onStop: PropTypes.func.isRequired,
	onRetry: PropTypes.func.isRequired,
	onNewChat: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
};

export default function ChatPanel({
	messages,
	isSending,
	onSend,
	onStop,
	onRetry,
	onNewChat,
	onClose,
}) {
	const inputRef = useRef(null);

	useEffect(() => {
		inputRef.current?.focus();
	}, []);

	const headerButtonSx = { color: 'rgba(255,255,255,0.9)' };

	return (
		<Paper
			square
			elevation={0}
			role="complementary"
			aria-label={ChatTitle}
			onKeyDown={(event) => {
				if (event.key === 'Escape') {
					onClose();
				}
			}}
			sx={{
				height: '100%',
				width: '100%',
				display: 'flex',
				flexDirection: 'column',
				overflow: 'hidden',
			}}>
			<Box
				className="flex items-center gap-2 px-3 py-2"
				sx={{ backgroundColor: 'primary.main' }}>
				<Box className="flex h-8 w-8 items-center justify-center rounded-full bg-white/20">
					<AutoAwesomeIcon sx={{ fontSize: 18, color: '#fff' }} />
				</Box>
				<Box className="min-w-0 flex-1">
					<Box className="truncate text-[14px] font-semibold text-white">
						{ChatTitle}
					</Box>
					<Box className="truncate text-[11px] text-white/80">
						{ChatSubtitle}
					</Box>
				</Box>

				<Tooltip title="New chat">
					<span>
						<IconButton
							size="small"
							aria-label="New chat"
							disabled={!messages.length && !isSending}
							onClick={onNewChat}
							sx={headerButtonSx}>
							<RestartAltIcon sx={{ fontSize: 20 }} />
						</IconButton>
					</span>
				</Tooltip>
				<Tooltip title="Close">
					<IconButton
						size="small"
						aria-label="Close assistant"
						onClick={onClose}
						sx={headerButtonSx}>
						<CloseIcon sx={{ fontSize: 20 }} />
					</IconButton>
				</Tooltip>
			</Box>

			<ChatThread
				messages={messages}
				isSending={isSending}
				onRetry={onRetry}
				onSuggestion={onSend}
			/>

			<ChatComposer
				isSending={isSending}
				inputRef={inputRef}
				onSend={onSend}
				onStop={onStop}
			/>
		</Paper>
	);
}
